import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Top accent bar */}
      <div className="h-1 w-full bg-orange-500" />

      <div className="mx-auto max-w-4xl px-6 py-12">
        {/* Header */}
        <div className="mb-8">
          <p className="text-sm text-white/70">Legal</p>
          <h1 className="mt-2 text-3xl font-extrabold tracking-tight">
            Terms of Use
          </h1>
          <p className="mt-2 text-white/70">
            Last updated: <span className="text-white">2026-02-02</span>
          </p>
       </div>

        {/* Card */}
        <div className="rounded-2xl border border-white/10 bg-black/5 p-6 shadow-xl">
          <p className="text-white/80 leading-relaxed">
            BuildBright is a lead-matching and marketing platform. We do not
            provide contracting or construction services ourselves. Any work on
            your property is performed by independent contractors who are solely
            responsible for their services, licensing, insurance, and compliance
            with applicable laws.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">No guarantees</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            Information on this site is for general informational purposes only
            and does not constitute professional, legal, or financial advice,
            and is not a guarantee of pricing, availability, or specific
            results.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Your responsibility</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            By using this site you agree to communicate and contract directly
            with your chosen contractors and to perform your own due diligence
            before hiring anyone to work on your property (including verifying
            licensing, insurance, references, and written scope/pricing).
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Contractors</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            Contractors are independent businesses. BuildBright does not
            supervise, direct, or control contractors and is not responsible for
            their workmanship, pricing, schedules, warranties, or conduct.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Messaging consent (SMS/email)</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            By submitting a form or requesting contact through BuildBright, you
            agree to receive messages (including SMS) related to your request
            and project updates. Message frequency varies. Reply STOP to opt
            out.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Important note</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            This page is a basic summary and may not satisfy all legal
            requirements for your jurisdiction. You should consult a licensed
            attorney to review and customize full terms of use for your
            business.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/privacy"
              className="inline-flex items-center justify-center rounded-full border border-white/15 bg-black/5 px-5 py-2 text-sm font-semibold text-white hover:bg-black/10"
            >
              View Privacy Policy
            </Link>

            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full bg-orange-600 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-700"
            >
              Back to Home
            </Link>
          </div>
        </div>

        {/* Footer note */}
        <p className="mt-8 text-xs text-white/50">
          © {new Date().getFullYear()} BuildBright. All rights reserved.
        </p>
      </div>
    </div>
  );
}

